import { add, navigation } from './url';

export function forceLogin(url) {
  const param = {
    v: 't',
    appid: 100,
    returnurl: url
  };
  console.log('login param:', param);

  navigation('https://plogin.m.jd.com/user/login.action', param);
}

/**
 * web前端登录，
 * @method function
 * @param {[object]} options [跳转参数]
 * @return {[type]} [description]
 */
export default function(options) {
  options = options || {};

  const hash = window.location.href.split('#');

  let _param = {};
  try {
    if (hash && hash.length > 1) {
      if (hash[1]) {
        let query = hash[1].split('?');
        if (query && query.length > 1) {
          query = query[1].split('&');
          if (query && query.length > 0) {
            $.each(query, function(key, val) {
              val = val.split('=');
              if (val && val.length > 1) {
                _param[val.shift()] = val.join('=');
              }
            });
          }
        }
      }
    }
  } catch (error) {
    console.log(error);
  }

  let url = '';
  if (hash && hash.length > 1) {
    url = add(add(hash[0], _param), options);
    url += '#' + hash[1];
  } else {
    url = add(window.location.href, options);
  }

  forceLogin(url);
}
